import React from "react";
import { motion } from "framer-motion";
import { REVEAL } from "@/lib/motion";
import { BRAND_GLYPHS } from "@/config/brandGlyphs";

// Nine marks ship as path data; the three the owners do not license openly were supplied by the client.
const TOOLS = [
  { label: "lemlist", image: "/tool-logos/lemlist.png", shape: "rounded-full" },
  { label: "Pipedrive", image: "/tool-logos/pipedrive.png", shape: "rounded-[5px]" },
  { glyph: "hubspot" },
  { glyph: "zoho" },
  { label: "Salesforce", image: "/tool-logos/salesforce.png", wordmark: true },
  { glyph: "n8n" },
  { glyph: "make" },
  { glyph: "zapier" },
  { glyph: "whatsapp" },
  { glyph: "googlesheets" },
  { glyph: "calendly" },
  { glyph: "claude" },
];

const Chip = ({ tool }) => {
  const glyph = tool.glyph ? BRAND_GLYPHS[tool.glyph] : null;
  const label = glyph ? glyph.name : tool.label;

  return (
    <span
      className="shrink-0 h-12 flex items-center gap-3 rounded-2xl border border-[#1F1F1C]/20 bg-[#EADCC6] px-5 text-sm font-semibold text-[#1F1F1C] transition-colors duration-300 hover:border-[#C8703A]"
      data-testid={`tool-chip-${label.toLowerCase().replace(/ /g, "-")}`}
    >
      {glyph && (
        <svg viewBox="0 0 24 24" className="w-5 h-5 shrink-0" style={{ color: glyph.hex }} fill="currentColor" aria-hidden="true">
          <path d={glyph.path} />
        </svg>
      )}
      {tool.image && (
        <img
          src={tool.image}
          alt={`${label} logo`}
          className={tool.wordmark ? "h-7 w-auto" : `w-5 h-5 shrink-0 object-contain ${tool.shape}`}
          loading="lazy"
        />
      )}
      {!tool.wordmark && label}
    </span>
  );
};

export const HomeTools = () => (
  <section className="px-6 sm:px-8 pb-20 sm:pb-28" data-testid="home-tools">
    <div className="max-w-5xl mx-auto">
      <motion.h2 {...REVEAL} className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#1F1F1C]">
        Works with the tools you already use.
      </motion.h2>
    </div>

    <div className="marquee mt-10 overflow-hidden -mx-6 sm:-mx-8" data-testid="tools-marquee">
      <div className="marquee-track flex gap-3">
        {[...TOOLS, ...TOOLS].map((t, i) => (
          <Chip key={`${t.glyph || t.label}-${i}`} tool={t} />        ))}
      </div>
    </div>
  </section>
);

export default HomeTools;
